import {useEffect, useState} from 'react'

import {analytics} from 'configs/firebase'
import useAuthState from './useAuthState'
import {signInAnonymously} from 'utils/login.utils'

export default function useAuthStateWithAnonymousSignIn() {
  const [user, loading, error] = useAuthState()
  const [signInError, setSignInError] = useState(null)

  useEffect(() => {
    if (signInError) return
    if (loading) return

    if (user) {
      analytics && analytics.setUserId(user.uid, {global: true})
      return
    }

    if (!user && !error) {
      signInAnonymously().catch(err => setSignInError(err))
    }
  }, [user, loading, error, signInError])

  return [user, loading, error || signInError]
}
